export default __webpack_public_path__ + "static/media/illustration-study-1-m.2c8b00bf.webp";